import { useContext, useMemo } from "react";
import AuthContext from "../../../components/AuthContext";
import type { ReactCurrentUser } from "../../Contexts/ReactRuntimeBridge";

/** Project only public identity fields; never expose the MSAL account or its claims. */
export function useReactCurrentUser(): ReactCurrentUser | undefined {
  const auth = useContext(AuthContext);
  const id = typeof auth.account?.localAccountId === "string" ? auth.account.localAccountId.trim() : "";
  const name = [auth.account?.name, auth.account?.displayName, auth.account?.username]
    .find((value): value is string => typeof value === "string" && value.trim().length > 0)?.trim() ?? "";

  return useMemo(
    () => auth.isAuthenticated && id ? Object.freeze({ Id: id, Name: name }) : undefined,
    [auth.isAuthenticated, id, name]
  );
}
